export default __webpack_public_path__ + "static/create-flag-dark-37422d5d2d542fe80488295e0c1a86a9.png";